import { render, staticRenderFns } from "./ToothRemoveMenu.vue?vue&type=template&id=26999256&scoped=true&"
import script from "./ToothRemoveMenu.vue?vue&type=script&lang=js&"
export * from "./ToothRemoveMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26999256",
  null
  
)

export default component.exports